import SchoolIcon from "@mui/icons-material/School";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import HistoryIcon from "@mui/icons-material/History";
import InfoIcon from "@mui/icons-material/Info";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import LanguageIcon from "@mui/icons-material/Language";

/** Data */
export const data = [
  {
    name: "STUDENT PORTAL",
    Icon: AccountBoxIcon,
    class_name: "Portal",
    p_class: "L",
    href: "https://student.tmuc.ac.ke/",
  },
  {
    name: "E-LEARNING",
    Icon: LibraryBooksIcon,
    class_name: "Elearning",
    p_class: "E",
    href: "https://elearning.tmuc.ac.ke/",
  },
  {
    name: "SCHOOL WEBSITE",
    Icon: LanguageIcon,
    class_name: "Portal",
    p_class: "HB",
    href: "https://tmuc.ac.ke/",
  },
  {
    name: "LIBRARY",
    Icon: LocalLibraryIcon,
    class_name: "Library",
    p_class: "LB",
    href: "https://tmuc.ac.ke/library-home",
  },
  {
    name: "SCHOOL PHOTOS",
    Icon: InsertPhotoIcon,
    class_name: "Photos",
    p_class: "P",
    href: "https://www.google.com/maps/uv?pb=!1s0x19d4d455c5c14c23%3A0x49c2401d906f4a6!3m1!7e115!4shttps%3A%2F%2Flh5.googleusercontent.com%2Fp%2FAF1QipP4WgWGyXr99V12ReGAzwwAqzgBRBScFMN3Q39U%3Dw120-h160-k-no!5stmuc%20-%20Google%20Search!15sCgIgAQ&imagekey=!1e10!2sAF1QipNMYCopuu9kCfQfWj2rwpHmO7iuIZg0G0Gu1EoR&hl=en&sa=X&ved=2ahUKEwjChY-hrPvxAhUXA2MBHUCyAqwQoiowEnoECEIQAw&viewerState=ga",
  },
  {
    name: "SCHOOL COUNCIL",
    Icon: AdminPanelSettingsIcon,
    class_name: "Council",
    p_class: "C",
    href: "https://tmuc.ac.ke/management-staff",
  },
  {
    name: "SCHOOL HISTORY",
    Icon: HistoryIcon,
    class_name: "History",
    p_class: "H",
    href: "https://tmuc.ac.ke/our-history",
  },
  {
    name: "DOWNLOADS",
    Icon: CloudDownloadIcon,
    class_name: "Downloads",
    p_class: "D",
    href: "https://tmuc.ac.ke/downloads",
  },
  {
    name: "DIRECTION",
    Icon: FmdGoodIcon,
    class_name: "Direction",
    p_class: "P",
    href: "https://www.google.com/maps/dir//Tom+Mboya+University+College,+C19,+Homabay,+Kenya,+Homabay/@-0.584245,34.387713,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x19d4d455c5c14c23:0x49c2401d906f4a6!2m2!1d34.387713!2d-0.584245!3e0",
  },
  {
    name: "ACADEMICS",
    Icon: SchoolIcon,
    class_name: "Academics",
    p_class: "C",
    href: "https://tmuc.ac.ke/undergraduateprogrammes",
  },
  {
    name: "ABOUT TMUC",
    Icon: InfoIcon,
    class_name: "About",
    p_class: "A",
    href: "https://tmuc.ac.ke/about-us",
  },
  {
    name: "HELB PORTAL",
    Icon: AttachMoneyIcon,
    class_name: "Portal",
    p_class: "HB",
    href: "https://www.helb.co.ke/student-portal/",
  },
];
